import { useState, useEffect } from 'react';
import { isBrowser } from '../utils';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = isBrowser ? window : { innerWidth: 768, innerHeight: 1024 };
  return {
    width,
    height,
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}
